import {
  type CategoryTabOptions,
  type DropdownOptions,
  type EventListApiResponse,
  type Filters,
  type NoticeApiResponse,
  type NoticeCategoryApiResponse,
  type NoticeDetailApiResponse,
  type NoticeDetailResponse,
  type NoticeResponse,
} from '~/features/notice/types/notice'
import { END_POINTS, get } from '~/shared/http-client/api'

export const getNoticeEventList = async (): Promise<DropdownOptions[]> => {
  const response: EventListApiResponse = await get(END_POINTS.notice.eventList)

  const eventList = response.data.eventInfo
    .sort((a, b) => b.round - a.round)
    .map((event) => ({
      value: event.id,
      label: `${event.round}회`,
    }))

  eventList.unshift({ value: 0, label: '전체 회차' })

  return eventList
}

export const getNoticeCategory = async (): Promise<CategoryTabOptions[]> => {
  const response: NoticeCategoryApiResponse = await get(
    END_POINTS.notice.category,
  )

  const categoryList = response.data.categoryList
    .sort((a, b) => a.sort - b.sort)
    .map((category) => ({
      value: category.code,
      label: category.description,
    }))

  return categoryList
}

export const getNoticeList = async (
  filters: Filters,
): Promise<NoticeResponse> => {
  const params = new URLSearchParams({
    page: filters.page.toString(),
    row_per_page: filters.row_per_page.toString(),
    category_code: filters.category_code,
    event_id: filters.event_id.toString(),
    keyword: filters.keyword,
  })

  const response: NoticeApiResponse = await get(
    `${END_POINTS.notice.list}?${params.toString()}`,
  )

  return response.data
}

export const getNoticeDetail = async (
  id: string,
): Promise<NoticeDetailResponse> => {
  const response: NoticeDetailApiResponse = await get(
    `${END_POINTS.notice.detail}/${id}`,
  )

  return response.data
}
